import React from 'react';

import {RemoveButton} from 'iss/widgets/Buttons';
import {FlexRow} from 'iss/widgets/Flex';
import {Input, ValidationErrorBox} from 'iss/widgets/Forms';
import validators, {validatorFrom} from 'iss/widgets/form/validation/validators';

/** A small sub form used to edit activated evaluation locations
 * Locations are a type of specifier for activated contracts that
 * contain a name, address, city and some custon code string */
export function ContractLocationEditor({id, valuePath, onRemove, inline}) {
  const Container = inline ? InlineEditorContainer : React.Fragment;

  return <div id={id} className="contract-location-editor">
    <Container>
      <Input id={`${id}-name`} valuePath={[valuePath, "name"]}
        label="domain.activatedEvaluation.location.name" validate={validators.required}
        maxLength="255" showCounter={true}/>
      <Input id={`${id}-address`} valuePath={[valuePath, "address"]}
        label="domain.activatedEvaluation.location.address"
        maxLength="500" showCounter={true}/>
      <Input id={`${id}-city`} valuePath={[valuePath, "city"]}
        label="domain.activatedEvaluation.location.city"
        maxLength="255" showCounter={true}/>
      <Input id={`${id}-code`} valuePath={[valuePath, "code"]}
        label="domain.activatedEvaluation.location.code"
        maxLength="255" showCounter={true}/>
      {onRemove && <RemoveButton flex="none" onClick={onRemove}/>}
    </Container>
    <ValidationErrorBox id={id+"-address-validation"} valuePath={valuePath}
      validate={locationAddressValidator} />
  </div>;
}

function InlineEditorContainer(props) {
  return <FlexRow flexAllChildren alignItems="center" {...props} />;
}

const locationAddressValidator = [
  /* Together these validate that both address and city are given if either of them is given */
  validatorFrom( ({city, address}) => (address || !city), "domain.activatedEvaluation.location.shouldHaveAddressWhenCityIsGiven"),
  validatorFrom( ({city, address}) => (city || !address), "domain.activatedEvaluation.location.shouldHaveCityWhenAddressISGiven")
];



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/ContractLocationEditor.jsx